"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const style_1 = __importStar(require("./style"));
const buildControlsByCategory_1 = __importDefault(require("../../../shared/buildControlsByCategory"));
const FlatListItem_1 = __importDefault(require("../FlatListItem"));
const useFlatListItemWrapperStyle_1 = __importDefault(require("../../hooks/useFlatListItemWrapperStyle"));
const useContainerStyle_1 = __importDefault(require("../../hooks/useContainerStyle"));
const getItemLayoutSectionList_1 = __importDefault(require("../../../shared/getItemLayoutSectionList"));
const ItemSeparatorComponent_1 = __importDefault(require("../ItemSeparatorComponent"));
const useControlEvents_1 = __importDefault(require("../../../hooks/useControlEvents"));
const computeComplexUnit_1 = __importDefault(require("../../../ControlStyleFormaters/shared/computeComplexUnit"));
const useAppStateUpdateControlById_1 = __importDefault(require("../../../hooks/useAppStateUpdateControlById"));
const useAppAtomStyleFromControlStyle_1 = __importDefault(require("../../../hooks/useAppAtomStyleFromControlStyle"));
const useAppGetColorFromSpecification_1 = __importDefault(require("../../../hooks/useAppGetColorFromSpecification"));
const useAppGetFontSizeFromSpecification_1 = __importDefault(require("../../../hooks/useAppGetFontSizeFromSpecification"));
const useControlParentNotNewById_1 = __importDefault(require("../../../hooks/useControlParentNotNewById"));
const SectionListRenderer = ({ listControl, }) => {
    var _a, _b, _c, _d;
    const parent = (0, useControlParentNotNewById_1.default)(listControl.id);
    const [listHeights, setListHeights] = (0, react_1.useState)({
        header: 0,
        item: 0,
    });
    const [searchInput, setSearchInput] = (0, react_1.useState)('');
    const { Render, functions: { processor }, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const events = (0, useControlEvents_1.default)(listControl);
    const [listData, categories] = (0, react_1.useMemo)(() => (0, buildControlsByCategory_1.default)({
        categoryField: listControl.categoryField,
        controls: listControl.controls || [],
        processor,
        filterProperty: listControl.filterProperty,
        filterEnabled: !!listControl.filterEnabled,
        searchInput,
    }), [
        listControl.categoryField,
        listControl.controls,
        processor,
        listControl.filterProperty,
        listControl.filterEnabled,
        searchInput,
    ]);
    const getColor = (0, useAppGetColorFromSpecification_1.default)();
    const tabBackgroudColor = getColor((_b = (_a = listControl.listStyles) === null || _a === void 0 ? void 0 : _a.tab) === null || _b === void 0 ? void 0 : _b.background);
    const tabColor = getColor((_d = (_c = listControl.listStyles) === null || _c === void 0 ? void 0 : _c.tab) === null || _d === void 0 ? void 0 : _d.color);
    const overwritenStyle = Object.assign(Object.assign({}, listControl.style), { flexDirection: 'column' });
    const containerStyle = (0, useContainerStyle_1.default)(overwritenStyle, parent !== null && parent !== void 0 ? parent : null);
    const headerData = (0, react_1.useMemo)(() => categories.map((categoryName) => ({
        key: categoryName,
    })), [categories]);
    const onLayout = (0, react_1.useCallback)((prop) => (e) => {
        const { height } = e.nativeEvent.layout;
        setListHeights((prev) => (Object.assign(Object.assign({}, prev), { [prop]: height })));
    }, []);
    const scrollToLocation = (0, react_1.useMemo)(() => {
        if (!listControl.scrollToCategory) {
            return undefined;
        }
        const categoryIndex = categories.indexOf(listControl.scrollToCategory);
        if (categoryIndex === -1) {
            return undefined;
        }
        try {
            return {
                animated: true,
                itemIndex: 0,
                sectionIndex: categoryIndex,
            };
        }
        catch (error) {
            return undefined;
        }
    }, [listControl.scrollToCategory, categories]);
    const flatListItemContainer = (0, useFlatListItemWrapperStyle_1.default)(listControl);
    const updateControlById = (0, useAppStateUpdateControlById_1.default)();
    const getAtomStyle = (0, useAppAtomStyleFromControlStyle_1.default)();
    const getFontSize = (0, useAppGetFontSizeFromSpecification_1.default)();
    return (react_1.default.createElement(Render.View, { style: getAtomStyle(containerStyle) },
        listControl.filterEnabled && (react_1.default.createElement(Render.TextInput, { placeholder: listControl.filterPlaceholder || `Search by ${listControl.filterProperty}`, placeholderTextColor: "#bdbdbd", value: searchInput, onChangeText: setSearchInput, style: style_1.inputSearchStyle })),
        !listControl.noCategoriesTab && (react_1.default.createElement(Render.FlatList, { horizontal: true, data: headerData, renderItem: ({ item }) => {
                var _a, _b, _c, _d;
                return (react_1.default.createElement(Render.TouchableOpacity, { onPress: () => {
                        updateControlById({
                            control: listControl,
                            dataToUpdate: {
                                scrollToCategory: item.key,
                            },
                        });
                    }, style: Object.assign(Object.assign({}, style_1.default.tabContainer), { backgroundColor: tabBackgroudColor, height: (0, computeComplexUnit_1.default)((_b = (_a = listControl.listStyles) === null || _a === void 0 ? void 0 : _a.tab) === null || _b === void 0 ? void 0 : _b.heightTopBar), justifyContent: 'center' }) },
                    react_1.default.createElement(Render.Text, { style: Object.assign(Object.assign({}, style_1.default.tabText), { color: tabColor, fontSize: getFontSize((_d = (_c = listControl.listStyles) === null || _c === void 0 ? void 0 : _c.tab) === null || _d === void 0 ? void 0 : _d.fontSizeTopBar) }) }, item.key)));
            } })),
        react_1.default.createElement(Render.SectionList, { scrollToLocation: scrollToLocation, sections: listData, keyExtractor: (item) => item.key, stickySectionHeadersEnabled: false, onScroll: events === null || events === void 0 ? void 0 : events.onScroll, getItemLayout: (data, index) => ((0, getItemLayoutSectionList_1.default)({
                getItemHeight: () => listHeights.item,
                getSeparatorHeight: () => 0.5,
                getSectionHeaderHeight: () => listHeights.header,
                getSectionFooterHeight: () => 0,
                listHeaderHeight: 0,
            })(data || [], index)), horizontal: !!listControl.isHorizontal, ItemSeparatorComponent: ItemSeparatorComponent_1.default, renderSectionHeader: ({ section }) => {
                var _a, _b, _c, _d;
                return (react_1.default.createElement(Render.View, { style: {
                        backgroundColor: tabBackgroudColor,
                        height: (0, computeComplexUnit_1.default)((_b = (_a = listControl.listStyles) === null || _a === void 0 ? void 0 : _a.tab) === null || _b === void 0 ? void 0 : _b.heightSeparator),
                        justifyContent: 'center',
                    }, onLayout: onLayout('header') },
                    react_1.default.createElement(Render.Text, { style: Object.assign(Object.assign({}, style_1.default.sectionHeaderText), { color: tabColor, fontSize: getFontSize((_d = (_c = listControl.listStyles) === null || _c === void 0 ? void 0 : _c.tab) === null || _d === void 0 ? void 0 : _d.fontSizeSeparator) }) }, section.title)));
            }, renderItem: ({ item: { control: controlChild } }) => (react_1.default.createElement(FlatListItem_1.default, { control: controlChild, flatListItemContainer: flatListItemContainer, View: Render.View, onLayout: onLayout('item') })) })));
};
exports.default = SectionListRenderer;
